export const TIPO_ASIENTO = {
  APUNTE: 0,
  FACTURA_EMITIDA: 1,
  FACTURA_EMITIDA_RECTIFICATIVA: 2,
  FACTURA_RECIBIDA: 3,
  FACTURA_RECIBIDA_RECTIFICATIVA: 4,
  GASTO: 5,
  NOMINA: 6,
  COBRO: 7,
  PAGO: 8,
  AMORTIZACION: 9,
  ASIENTO_REG_CIERRE: 10,
  ASIENTO_DE_APERTURA: 11,
  ASIENTO_DE_CIERRE: 12,
  LIQUIDACION_DE_IMPUESTOS: 13,
} as const

export type TipoAsientoType = (typeof TIPO_ASIENTO)[keyof typeof TIPO_ASIENTO]

export const SHOW_IMPUESTOS_TABLE: Partial<TipoAsientoType[]> = [
  TIPO_ASIENTO.FACTURA_EMITIDA,
  TIPO_ASIENTO.FACTURA_EMITIDA_RECTIFICATIVA,
  TIPO_ASIENTO.FACTURA_RECIBIDA,
  TIPO_ASIENTO.FACTURA_RECIBIDA_RECTIFICATIVA,
]
export const SHOW_TAXES_VENTAS: Partial<TipoAsientoType[]> = [
  TIPO_ASIENTO.FACTURA_EMITIDA,
  TIPO_ASIENTO.FACTURA_EMITIDA_RECTIFICATIVA,
]

export const SHOW_TAXES_COMPRAS: Partial<TipoAsientoType[]> = [
  TIPO_ASIENTO.FACTURA_RECIBIDA,
  TIPO_ASIENTO.FACTURA_RECIBIDA_RECTIFICATIVA,
]
